import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MenuHeaderService {
  private urlNlweb: string = environment.API_NLWEB;
  private url: string = environment.API_URL_CMS;

  constructor(private http: HttpClient) {}

  getMenus(): Observable<any> {
    return this.http.get(`${this.url}/faixaNavegacao/ativos`);
  }

  buscaNlWeb(pergunta: string, perguntasAnteriores: string[]): Observable<string> {
    const queryId = `query_${Date.now()}_${Math.floor(Math.random() * 1e3)}`;
    const params = new URLSearchParams({
      query_id: queryId,
      query: pergunta,
      generate_mode: 'list',
      prev: JSON.stringify(perguntasAnteriores),
      item_to_remember: '',
      context_url: '',
    });
    const url = `${this.urlNlweb}/ask?${params.toString()}`;
    return new Observable((obs) => {
      const fluxoDeEventos = new EventSource(url);
      fluxoDeEventos.onmessage = (eventos) => obs.next(eventos.data);
      fluxoDeEventos.onerror = (erro) => {
        obs.error(erro);
        fluxoDeEventos.close();
      };
      return () => fluxoDeEventos.close();
    });
  }
}
